import api from './api';

const inventoryCountService = {
  getSettings(warehouseId) {
    return api.get(`/warehouses/${warehouseId}/inventory-counts/settings`).then((r) => r.data);
  },

  updateSettings(warehouseId, payload) {
    return api.patch(`/warehouses/${warehouseId}/inventory-counts/settings`, payload).then((r) => r.data);
  },

  listCampaigns(warehouseId) {
    return api.get(`/warehouses/${warehouseId}/inventory-counts/campaigns`).then((r) => r.data);
  },

  myAssignments() {
    return api.get('/audit/inventory-counts/my-assignments').then((r) => r.data);
  },

  createCampaign(warehouseId, payload) {
    return api.post(`/warehouses/${warehouseId}/inventory-counts/campaigns`, payload).then((r) => r.data);
  },

  syncCampaignProducts(warehouseId, campaignId, productIds) {
    return api.post(`/warehouses/${warehouseId}/inventory-counts/campaigns/${campaignId}/products`, {
      product_ids: productIds,
    }).then((r) => r.data);
  },

  activateCampaign(warehouseId, campaignId) {
    return api.patch(`/warehouses/${warehouseId}/inventory-counts/campaigns/${campaignId}/activate`).then((r) => r.data);
  },

  closeCampaign(warehouseId, campaignId) {
    return api.post(`/warehouses/${warehouseId}/inventory-counts/campaigns/${campaignId}/close`).then((r) => r.data);
  },

  getChecklist(warehouseId, campaignId) {
    return api.get(`/warehouses/${warehouseId}/inventory-counts/campaigns/${campaignId}/checklist`).then((r) => r.data);
  },

  saveLine(warehouseId, campaignId, payload) {
    return api.post(`/warehouses/${warehouseId}/inventory-counts/campaigns/${campaignId}/lines`, payload).then((r) => r.data);
  },
};

export default inventoryCountService;
